import FileSaver from "file-saver";

export const saveAs = (data, name, type) => {
  // for IE and Edge
  if (navigator.msSaveOrOpenBlob) {
    const blob = new Blob([data]);
    return navigator.msSaveOrOpenBlob(blob, name);
  }

  FileSaver.saveAs(new File([data], name, { type }));

  return true;
};



// WEBPACK FOOTER //
// ./src/helpers/fileHelpers.js